module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "ack"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("•")]), _vm._v(" Acknowledgments "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("•")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("A novel, particularly a first novel, is never published without many mercies, known and unknown. Thanks to Bill Reiss for taking a chance and being patient, and to Karen Wojtyla for shepherding a novice painlessly through the process. The Bridge School “older writers” served as a gracious and gratifying first audience. Blessings on you all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 60
// module chunks = 0